import React from 'react';
import {Route, Redirect} from 'react-router-dom';
import {
  getPhoneNumber,
  getSignUp,
  getUserType,
} from '../core/localstorage-data';
import {useAppSelector} from '../redux/hooks';
import {
  HOME_ROUTE_PATH,
  LANDING_PATH,
  LOGIN_ROUTE_PATH,
} from './route-constants';

interface IProps {
  exact?: boolean;
  path: string;
  component: React.ComponentType<any>;
}

/**
 * Used to protect routes if the user is not logged in
 * @param props
 * @returns
 */
export const AuthorizedRoute = (props: IProps) => {
  const userLogged: boolean = useAppSelector(
    state => state.globalReducer.isUserLoggedIn,
  );
  console.log('authorized route', userLogged);

  return userLogged ? (
    <Route {...props} />
  ) : (
    <Redirect to={{pathname: LANDING_PATH}} />
  );
};

/**
 * Used to redirect logged users from login or signup
 * @param props
 * @returns
 */
export const GuestRoute = (props: IProps) => {
  localStorage.removeItem('signup');
  const userLogged: boolean = useAppSelector(
    state => state.globalReducer.isUserLoggedIn,
  );

  console.log('guest route', userLogged);

  return userLogged ? (
    <Redirect to={{pathname: HOME_ROUTE_PATH}} />
  ) : (
    <Route {...props} />
  );
};

export const EmployeeRoutes = (props: IProps) => {
  const employeeLogged: boolean = useAppSelector(
    state => state.globalReducer.isEmployeeLoggedIn,
  );

  console.log('employee route', employeeLogged);

  return employeeLogged ? (
    <Redirect to={{pathname: LOGIN_ROUTE_PATH}} />
  ) : (
    <Route {...props} />
  );
};

export const AlternativeRoute = (props: IProps) => {
  const userLogged: any = getPhoneNumber() && getSignUp();

  console.log(getSignUp());
  return userLogged ? (
    <Route {...props} />
  ) : (
    <Redirect to={{pathname: LOGIN_ROUTE_PATH}} />
  );
};
